import WarehouseIcon from '@mui/icons-material/Warehouse'

import { STOP_TYPE } from 'settings/constants/service'
import T from 'T'

import type { ElementType } from 'react'

export interface RoutableStopKind {
  Glyph: ElementType
  fallbackLabel: string
  recurringLabel: string
}

const KINDS: Record<string, RoutableStopKind> = {
  [STOP_TYPE.DISPOSAL]: { Glyph: WarehouseIcon, fallbackLabel: T.DISPOSAL, recurringLabel: T.RECURRING_DISPOSAL },
}

export const isRoutableStop = (stopType?: string | null): boolean => Boolean(stopType && stopType in KINDS)

export const routableStopKindOf = (stopType?: string | null): RoutableStopKind => (stopType && KINDS[stopType]) || KINDS[STOP_TYPE.DISPOSAL]
